import React from 'react'
import RaiseTicketsCards from './RaiseTicketsCards';

interface ColumnProps {
    name: string;
    tasks:  {
    ticket_id: string
    title: string
    description: string
    issue: string
    created_at: string
    attachment: string
    solution:string
  }[];
    handleDrop: (e: React.DragEvent, toColumn: string) => void;
    handleDragStart: (e: React.DragEvent, taskId: string, fromColumn: string) => void;
    openModal: (task: {  ticket_id: string; title: string }) => void; 
  }
  
  const RaiseTicketsColumns: React.FC<ColumnProps> =({ name, tasks, handleDrop, handleDragStart, openModal })=> {
    return (
      <div
      onDragOver={(e) => {
        e.preventDefault();  // Allows the drop event
        // e.dataTransfer.dropEffect = "move"; // Shows a move cursor
      }}
        onDrop={(e) => handleDrop(e, name)}
        style={{
          width: "40%",
          minHeight: "700px",
          maxHeight: "700px",
          backgroundColor: "#f4f4f4",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <h3
         style={{
          textAlign: "center",
          textTransform: "capitalize"
        }}
        >{name}</h3>
      <div
        style={{
          flexGrow: 1,
          overflowY: "auto", 
          scrollbarWidth: "thin",
          scrollbarColor: "#ccc transparent", 
        }}
      >
        {tasks.map((task) => (
          <RaiseTicketsCards key={task.ticket_id} task={task} column={name} handleDragStart={handleDragStart} openModal={openModal} />
        ))}
      </div>
      </div>
    );
  };

export default RaiseTicketsColumns